<template>
  <transition
    :css="false"
    @before-enter="beforeEnter"
    @enter="enter"
    @after-enter="afterEnter"
    @before-leave="beforeLeave"
    @leave="leave"
  >
    <slot />
  </transition>
</template>

<script>
import { TweenLite, Power4, Power3, Power1 } from 'gsap'

const duration = 0.5

export default {
  methods: {
    beforeEnter(el) {
      el.style.height = '0'
      el.style.overflow = 'hidden'
    },
    enter(el, done) {
      const targetHeight = el.scrollHeight + 'px'
      
      TweenLite.to(
        el,
        duration,
        {
          height: targetHeight,
          ease: Power4.easeOut,
          onComplete: done,
        },
      )
    },
    afterEnter(el) {
      el.style.height = 'auto'
    },
    beforeLeave(el) {
      el.style.height = el.scrollHeight + 'px'
    },
    leave(el, done) {
      TweenLite.to(
        el,
        duration,
        {
          height: '0',
          ease: Power1.easeOut,
          onComplete: done,
        },
      )
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/js/components/accordion/AccordionContainerTransition.vue